import React, { useEffect, useState } from "react";
import { FaEnvelope, FaUserTie, FaBoxOpen } from "react-icons/fa";
import axiosInstance from "../axiosInterceptor";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const fetchInquiryData = async (url, setData, setLoading, payload) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post(url, payload);
    const { data } = response.data;
    setData(data);
  } catch (error) {
    toast.error(
      error?.response?.data?.message ||
        "Something went wrong. Please try again!!",
    );
  } finally {
    setLoading(false);
  }
};

const Dashboard = () => {
  const navigator = useNavigate();
  const [contactLoading, setContactLoading] = useState(true);
  const [careerLoading, setCareerLoading] = useState(true);
  const [projectLoading, setProjectLoading] = useState(true);
  const [contactData, setContactData] = useState([]);
  const [careerData, setCareerData] = useState([]);
  const [projectData, setProjectData] = useState([]);

  const [counts, setCounts] = useState({
    contact: 0,
    career: 0,
    project: 0,
  });

  const fetchCounts = async () => {
    try {
      const response = await axiosInstance.get(`dashboard/getinquiryCount`);
      const { data } = response.data;
      setCounts(data);
    } catch (error) {
      setCounts({
        contact: 0,
        career: 0,
        product: 0,
      });
      toast.error("Something went wrong. Please try again!!");
    }
  };

  useEffect(() => {
    fetchCounts();
  }, []);

  const fetchContactInquiryData = () => {
    fetchInquiryData("contact/getContacts", setContactData, setContactLoading, {
      perPage: 10,
      pageNo: 1,
    });
  };

  const fetchCareerInquiryData = () => {
    fetchInquiryData("career/getCareers", setCareerData, setCareerLoading, {
      perPage: 10,
      pageNo: 1,
    });
  };

  const fetchProjectInquiryData = () => {
    fetchInquiryData(
      `inquiry/getInquiries`,
      setProjectData,
      setProjectLoading,
      { perPage: 10, pageNo: 1 },
    );
  };

  useEffect(() => {
    fetchContactInquiryData();
    fetchCareerInquiryData();
    fetchProjectInquiryData();
  }, []);
  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="page-title">Dashboard</h3>
      </div>

      <div className="row mt-4">
        <div className="col-md-4">
          <Link
            to="/contact-inquiry"
            className="text-decoration-none text-dark"
          >
            <div className="card shadow border-0">
              <div className="card-body">
                <h6 className="mb-3">Contact Inquiry</h6>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="icon-box bg-primary-light text-dark">
                    <FaEnvelope />
                  </div>

                  <h2 className="fw-bold mb-0">{counts?.contact || 0}</h2>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-4">
          <Link to="/careers" className="text-decoration-none text-dark">
            <div className="card shadow border-0">
              <div className="card-body">
                <h6 className="mb-3">Career Inquiry</h6>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="icon-box bg-success-light text-info">
                    <FaUserTie />
                  </div>

                  <h2 className="fw-bold mb-0">{counts?.career || 0}</h2>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="col-md-4">
          <Link
            to="/projects-inquiry"
            className="text-decoration-none text-dark"
          >
            <div className="card shadow border-0">
              <div className="card-body">
                <h6 className="mb-3">Project Inquiry</h6>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="icon-box bg-warning-light text-danger">
                    <FaBoxOpen />
                  </div>

                  <h2 className="fw-bold mb-0">{counts?.project || 0}</h2>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-sm-flex align-items-center mb-4">
                <h4 className="card-title mb-sm-0">Careers Inquiry</h4>
              </div>

              <div className="table-responsive border rounded p-1">
                <table className="table text-left">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Post</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {careerLoading ? (
                      <tr>
                        <td colSpan="4" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : careerData.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      careerData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td>{item.post}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() =>
                                navigator("/view-career", { state: item })
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-sm-flex align-items-center mb-4">
                <h4 className="card-title mb-sm-0">Contact Inquiry</h4>
              </div>

              <div className="table-responsive border rounded p-1">
                <table className="table text-left">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Subject</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {contactLoading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : contactData.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      contactData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td>{item.phoneNumber}</td>
                          <td>{item.subject}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() =>
                                navigator("/view-contact", { state: item })
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="d-sm-flex align-items-center mb-4">
                <h4 className="card-title mb-sm-0">Projects Inquiries</h4>
              </div>

              <div className="table-responsive border rounded p-1">
                <table className="table text-left">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Project</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {projectLoading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : projectData.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No data found
                        </td>
                      </tr>
                    ) : (
                      projectData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.email}</td>
                          <td>{item.phoneNumber}</td>
                          <td>{item.project}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() =>
                                navigator("/view-inquiry", { state: item })
                              }
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
